/**
 * Toast messages for the tax-closing-period gate (release / block monthly
 * fiscal periods). Centralized to keep wording consistent.
 */

type ToastVariant = "default" | "destructive";

interface ToastPayload {
  title: string;
  description?: string;
  variant?: ToastVariant;
}

export const PERIOD_GATE_TOASTS = {
  releaseSuccess: (monthLabel: string, year: number): ToastPayload => ({
    title: "Mês liberado com sucesso",
    description: `${monthLabel}/${year} pode receber extrações.`,
  }),
  releaseError: (description: string): ToastPayload => ({
    title: "Erro ao liberar mês",
    description,
    variant: "destructive",
  }),
  blockSuccess: (monthLabel: string, year: number): ToastPayload => ({
    title: "Mês bloqueado com sucesso",
    description: `${monthLabel}/${year} não aceitará novas extrações.`,
  }),
  blockError: (description: string): ToastPayload => ({
    title: "Erro ao bloquear mês",
    description,
    variant: "destructive",
  }),
} as const;
